import { render } from "./SaveMembership.vue?vue&type=template&id=9bd90f12"
import script from "./SaveMembership.vue?vue&type=script&lang=js"
export * from "./SaveMembership.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__